import { useState, useEffect, useContext, useRef } from 'react';

import { get_time_by_sec } from '../../../../../../util/utility';
import { cmnContext } from '../../../../../common/CmnContext';
import { SaleListContext } from '../../../SaleListContext';


export function SaleListDetailSeriesItem(props: any) {

  const available = props.available;
  const dispIndex = props.dispIndex;
  const setDispIndex = props.setDispIndex;
  const index = props.index;
  const saleImage = props.saleImage;
  const movieTitle = props.movieTitle;
  const movieTimeList = props.movieTimeList;

  const isPc = useContext(cmnContext).isPc;
  const grayColor = useContext(SaleListContext).grayColor;

  const [itemBackClr, setItemBackClr] = useState<string>(grayColor);
  const [itemFntClr, setItemFntClr] = useState<string>('black');

  // 動画時間
  const [dispTime, setDispTime] = useState<string>('');


  useEffect(() => {
    if(available) {
      if(index == dispIndex) {
        setItemBackClr('black');
        setItemFntClr('white');
      } else {
        setItemBackClr(grayColor);
        setItemFntClr('black');
      }
    } else {
      setItemBackClr(grayColor);
      setItemFntClr('black');
    }
  }, [available, dispIndex])

  // 動画時間
  useEffect(() => {
    if(movieTimeList && movieTimeList[index]) {
      setDispTime(get_time_by_sec(movieTimeList[index]));
    }
  }, [index, movieTimeList])


  const onPress = () => {
    if(available) {
      setDispIndex(index);
    }
  }


  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: isPc ? 'center' : 'flex-start',
        justifyContent: 'flex-start',
        padding: isPc? '3% 1%':'5% 0%',
        borderTopColor: '#fff',
        borderTopStyle: 'solid',
        borderTopWidth: '2px',
        backgroundColor: itemBackClr,
      }}
      onClick={onPress}
    >

      <span style={{
        color: itemFntClr,
        fontSize: isPc? '120%': '100%',
        fontWeight: 'bold',
      }}>{index+1}</span>

      <div style={{
        display: 'flex',
        flexDirection: isPc ? 'row' : 'column',
        alignItems: isPc ? 'center' : 'flex-start',
        marginLeft: '10px',
        flex: 1,
      }}>
        <div style={{
          position: 'relative',
          width: isPc ? '50%' : '100%',
          flexShrink: 0,
          marginRight: isPc ? '10px' : '0px',
        }}>
          <img
            src={`/images/sale/${saleImage}`}
            style={{
              display: 'block',
              width: '100%',
              objectFit: 'contain',
              objectPosition: 'center',
            }}
            alt={movieTitle}
          />
          {dispTime &&
            <span style={{
              position: 'absolute',
              bottom: '4px',
              right: '4px',
              backgroundColor: 'rgba(0,0,0,0.8)',
              color: '#fff',
              fontSize: '14px',
              fontWeight: 'bold',
              padding: '2px 6px',
              borderRadius: '3px',
              lineHeight: 1.2,
            }}>{dispTime}</span>
          }
        </div>
        <span style={{
          color: itemFntClr,
          fontWeight: 'bold',
          marginTop: isPc ? '0px' : '5px',
        }}>{movieTitle}</span>
      </div>

    </div>
  );
}